var React = require('react');

function IconWebpack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.0779 25.5333L15.5922 33.1278V27.2131L23.9942 22.6111L29.0779 25.5333ZM30 24.7009V8.81752L25.0653 11.6541V21.863L30 24.7009ZM0.922058 25.5333L14.4078 33.1278V27.2131L6.0058 22.6097L0.922058 25.5319V25.5333ZM0 24.7009V8.81752L4.93466 11.6541V21.863L0 24.7009ZM0.576976 7.79056L14.4078 0V5.71869L5.54753 10.5733L5.47989 10.6119L0.576976 7.79056ZM29.423 7.79056L15.5922 0V5.71869L24.4525 10.5719L24.5201 10.6106L29.423 7.79056ZM14.4065 25.8673L6.1176 21.3302V12.3374L14.4065 17.1036V25.8673ZM15.5908 25.8673L23.8796 21.3302V12.3374L15.5908 17.1036V25.8673ZM6.6794 11.298L15.0028 6.74013L23.3234 11.2966L15.0014 16.0822L6.6794 11.298Z","fill":"#fff"}));
}

IconWebpack.defaultProps = {"width":"30","height":"34","viewBox":"0 0 30 34","fill":"none"};

module.exports = IconWebpack;

IconWebpack.default = IconWebpack;
